import { injectCpmsBoTransactionReportsEcologyStatisticsApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-transaction-reports-ecology-statistics';

import { baseApi } from '@service/base-api.service';

export const cpmsBoTransactionReportsEcologyStatisticsApi =
  injectCpmsBoTransactionReportsEcologyStatisticsApi(baseApi);

export const { useCpmsBoGetEcologicalImpactQuery } =
  cpmsBoTransactionReportsEcologyStatisticsApi;
